import type React from "react";
import { ReactComponent as Svg } from "./assets/small-chevron.svg";
import * as styles from "./Icon.module.scss";

type SmallChevronProps = React.SVGProps<SVGSVGElement>;

export const SmallChevron = ({ className, ...props }: SmallChevronProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
